/**
 * The server's error message from a failed HttpClient call — Nest's
 * `{ statusCode, message, error }` body, where `message` is a string or (for
 * validation failures) a string[] — falling back to `fallback` when there
 * isn't one (network failure, non-HTTP error, empty body).
 */
export function httpErrorMessage(err: unknown, fallback: string): string {
  const message = (err as { error?: { message?: unknown } } | null)?.error?.message;
  if (typeof message === 'string' && message.trim()) return message;
  if (Array.isArray(message)) {
    const parts = message.filter((m): m is string => typeof m === 'string' && !!m.trim());
    if (parts.length) return parts.join('. ');
  }
  return fallback;
}
